import { LocaleService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { resolveProps } from '@philips-internal/oswald-ui-engine/lib/utils/index.js';
import { getBreakpoint } from '@philips-internal/oswald-ui-utils';
/**
 * Updates the children of a node and invokes the rendering process with the updated children.
 *
 * @param parameters - Parameters for updating the node's children.
 */
function updateNodeChildren(parameters) {
    const metadata = parameters.root.getMetadata();
    const elements = [];
    const renderNode = (child) => {
        const element = parameters.engine.render(child);
        elements.push(element);
    };
    for (const child of parameters.nodes) {
        const exists = metadata.getNode(child.props.uuid);
        if (exists) {
            renderNode(child);
            continue;
        }
        metadata.addChildNode(parameters.node, child);
        renderNode(child);
    }
    parameters.setChildren(elements);
}
/**
 * Updates a node with the provided properties and notifies the changes to the node Single Source Of Truth.
 *
 * @param parameters - Parameters for updating the node.
 */
function updateNode(parameters) {
    const breakpoint = getBreakpoint();
    const locale = LocaleService.getCurrentLocale();
    const resolvedProps = resolveProps(parameters.props, breakpoint, locale);
    const ssot = parameters.root.getChild(parameters.uuid)?.getSSOT();
    ssot.applyAndNotify(resolvedProps);
}
export { updateNode, updateNodeChildren, };
//# sourceMappingURL=preview-selectable-utils.js.map